/**
 * LWB Wishlist — Central wishlist manager
 * Uses localStorage key: lwb_wishlist
 * Product object: { id, title, handle, image, url, price }
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lwb_wishlist';

  var LWBWishlist = {

    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },

    save: function (list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    },

    has: function (id) {
      return !!this.get().find(function (i) { return i.id === id; });
    },

    add: function (product) {
      var list = this.get();
      if (!list.find(function (i) { return i.id === product.id; })) {
        list.push(product);
        this.save(list);
      }
      this.syncUI();
    },

    remove: function (id) {
      var list = this.get().filter(function (i) { return i.id !== id; });
      this.save(list);
      this.syncUI();
    },

    toggle: function (product) {
      if (this.has(product.id)) {
        this.remove(product.id);
        return false;
      } else {
        this.add(product);
        return true;
      }
    },

    count: function () {
      return this.get().length;
    },

    /* ── UI sync ── */
    syncUI: function () {
      var count = this.count();

      /* Header badge */
      document.querySelectorAll('.lwb-wl-badge').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });

      /* All wishlist buttons on the page */
      var self = this;
      document.querySelectorAll('[data-wl-id]').forEach(function (btn) {
        var id = parseInt(btn.dataset.wlId, 10);
        var active = self.has(id);
        btn.classList.toggle('lwb-wl-active', active);
        btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      });
    },

    /* ── Premium toast ── */
    toast: function (msg, link) {
      var t = document.getElementById('lwb-wl-toast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'lwb-wl-toast';
        t.className = 'lwb-wl-toast';
        document.body.appendChild(t);
      }
      t.innerHTML =
        '<span class="lwb-wl-toast__msg">' + msg + '</span>' +
        (link ? '<a class="lwb-wl-toast__link" href="/pages/wishlist">View Wishlist &rsaquo;</a>' : '');
      t.classList.remove('lwb-wl-toast--out');
      t.classList.add('lwb-wl-toast--in');
      clearTimeout(t._lwbTimer);
      t._lwbTimer = setTimeout(function () {
        t.classList.remove('lwb-wl-toast--in');
        t.classList.add('lwb-wl-toast--out');
      }, 3200);
    },

    /* ── Init ── */
    init: function () {
      this.syncUI();
      var self = this;

      /* Delegated click handler — works for any button with data-wl-product */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wl-product]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var product;
        try { product = JSON.parse(btn.dataset.wlProduct); }
        catch (err) { return; }

        var added = self.toggle(product);

        if (added) {
          self.toast('♥ Added to Wishlist', true);
        } else {
          self.toast('Removed from Wishlist', false);
        }
      });
    }
  };

  /* Expose globally */
  window.LWBWishlist = LWBWishlist;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { LWBWishlist.init(); });
  } else {
    LWBWishlist.init();
  }
})();
